const addressAction = (state = "", action) => {
    switch(action.type) {
        case 'addressAction':
            return action.payload;
        default:
            return state;
    }
}

export default addressAction;